import {Route, Switch} from 'react-router-dom';
import {OVRToolkitV2} from '../../ovr/OVRToolkitV2';
export const OVR_TOOLKIT_ROUTES_PREFIX = '/ovr-toolkit';
export const OVR_TOOLKIT_ROUTES = {
  MAIN: `${OVR_TOOLKIT_ROUTES_PREFIX}/main`,
};

export const OVRToolkitRoutes = () => {
  return (
    <Switch>
      <Route
        path={OVR_TOOLKIT_ROUTES.MAIN}
        exact={true}
        component={OVRToolkitV2}
      />
    </Switch>
  );
};
